<template>
  <p class="image">
    <img :src="url" :alt="$t('title.photo')" />
  </p>
</template>

<script>
export default {
  props: {
    url: { type: String, required: true }
  }
}
</script>
